import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/AddCrt';
import { useAuthValidation } from '../../utils/hooks';

const AddCrtPage = () => {
  useAuthValidation();

  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default AddCrtPage;
